import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { LoadingButton } from '@mui/lab';
import { Button, CardContent, DialogTitle, ListItemIcon, Paper } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const TwitterAuthorizationModal = (props) => {
  const { t: translate } = useTranslation();
  const [isLoadingOn, setLoadingOn] = useState(false);

  const handleConnectTwitter = () => {
    setLoadingOn(true);
    props.handleConnectTwitter();
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open>
      <DialogTitle id="customized-dialog-title">
        <Typography gutterBottom variant="h4">
        {props.reAuth
            ? `${translate('integration.twitter.renew_access_permission')}`
            : `${translate('integration.twitter.authorize_to_access')}`}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        <CardContent sx={{ p: { xs: 0, md: 0 }, color: 'grey.800' }}>
          <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 2 }}>
          {props.reAuth
              ? `${translate('integration.twitter.verify_update_permissions')}:`
              : `${translate('integration.twitter.application_request_access')}:`}
          </Typography>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
            {props.reAuth
                ? `${translate('integration.twitter.verify_existing_access')}:`
                : `${translate('integration.twitter.read_access_to_tweets')}:`}
            </Typography>
          </Paper>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
            {props.reAuth
                ? `${translate('integration.twitter.renew_write_permission')}`
                : `${translate('integration.twitter.read_write_access')}`}
            </Typography>
          </Paper>

          {!props.reAuth && (
            <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
              <ListItemIcon>
                <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
              </ListItemIcon>
              <Typography variant="body1">{translate('integration.twitter.access_to_direct_messages')}</Typography>
            </Paper>
          )}
        </CardContent>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
        {translate('common.close')}
        </Button>
        <LoadingButton
          variant="contained"
          loading={isLoadingOn}
          autoFocus
          onClick={() => {
            handleConnectTwitter();
          }}
        >
          {props.reAuth ? `${translate('common.reconnect')}` : `${translate('common.connect')}`}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default TwitterAuthorizationModal;
